module.exports = __webpack_public_path__ + "static/media/accordion_up_icon.4c737c7e.svg";